export default "__VITE_ASSET__CnsL73Js__"